import { apiClient } from "./client";

export async function sendAssistantMessage(id, message) {
  const res = await apiClient.post("/dash/assistant/message", { id, message });
  return res.data;
}

export async function getAssistantHistory(id) {
  const res = await apiClient.post("/dash/assistant/history", { id });
  return res.data;
}

export async function clearAssistantHistory(id) {
  const res = await apiClient.post("/dash/assistant/clear", { id });
  return res.data;
}
